import { Task } from "./Tasks.js";
export const TasksManager = {
    _tasks: new Map(),
    registerTasks(id, run, mode = "async") {
        const tasks = new Task(id, run, mode);
        this._tasks.set(id, tasks);
        return tasks;
    },
    getTasks(id) {
        const tasks = this._tasks.get(id);
        if (!tasks)
            return false;
        return tasks;
    },
};
